var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _g, _rect5, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 388H396V406H78V388Z",
    fill: "url(#paint0_linear_106_1089)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297 296H396V314H297V296Z",
    fill: "url(#paint1_linear_106_1089)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297 213H396V231H297V213Z",
    fill: "url(#paint2_linear_106_1089)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297 254H396V272H297V254Z",
    fill: "url(#paint3_linear_106_1089)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 443H396V461H78V443Z",
    fill: "url(#paint4_linear_106_1089)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 265,
    height: 111,
    fill: "#6F42C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_1089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1264 41.1818L61.5014 66.75H62.0469L77.4901 41.1818H91.9105L70.3991 76.0909L92.2514 111H77.5923L62.0469 85.6023H61.5014L45.956 111H31.3651L53.4219 76.0909L31.6378 41.1818H46.1264ZM101.839 41.1818H117.317L138.044 91.7727H138.862L159.589 41.1818H175.067V111H162.93V63.0341H162.283L142.987 110.795H133.919L114.624 62.9318H113.976V111H101.839V41.1818ZM188.839 111V41.1818H201.487V100.398H232.237V111H188.839Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 171,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#6F42C1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.781 269.386V261.386L149.781 247.295V256.5L127.872 265.295L128.168 264.818V265.955L127.872 265.477L149.781 274.273V283.477L117.781 269.386ZM179.668 235.273L164.668 291H156.327L171.327 235.273H179.668ZM218.219 269.386L186.219 283.477V274.273L208.128 265.477L207.832 265.955V264.818L208.128 265.295L186.219 256.5V247.295L218.219 261.386V269.386Z",
    fill: "#FAFAFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_1089",
    x: 19.3633,
    y: 41.1836,
    width: 216.875,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_1089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_1089",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C68CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F42C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_1089",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C68CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F42C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_1089",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C68CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F42C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_1089",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C68CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F42C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_1089",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C68CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F42C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.755551c56e440d58811fa662f144d7d9.svg";
export { ForwardRef as ReactComponent };